import Temp from "@/courier/Temp";
import {courierDetail as _COURIERS_} from "@/config/courierCodes";
export default class DHLExpress extends Temp {
  static CODE = _COURIERS_.DHL.key;

  constructor() {
    super(DHLExpress.CODE);
  }
  getZone(item) {
    let type;
    let cross_price, remote_area;
    cross_price = remote_area = 0;
    // let prefixFromPostCode = item.fromPostcode.toString().substring( 0 , 2 )
    type = super.checkZone(item.toPostcode.toString());
    if (type == 3) type = 2;
    if (type > 3) type = 3;
    return {
      rate_type: type,
      rate_remote_area: remote_area,
      cross_price: cross_price,
    };
  }
  checkDimension(dimensionCourier, item, validate) {
    return super.checkCourierDimension(dimensionCourier, item, validate);
  }
  checkWeight(courierRates, item) {
    item.index = courierRates.findIndex((rate) => {
      return item.weight >= rate.min && item.weight <= rate.max;
    });
    return {
      index: item.index,
    };
  }
}
